import { BodyText, FlexDynamic } from '@minecraft.atoms';
import React from 'react';

export const TooltipText = ({ children }) => {
  return (
    <FlexDynamic
      maxWidth={20}
      smProps={{ maxWidth: 25 }}
      mdProps={{ maxWidth: 32 }}
      lgProps={{ maxWidth: 42 }}
      xlProps={{ maxWidth: 55 }}
      direction="column"
      wrap="nowrap"
      alignItems="center"
      justifyContent="center"
    >
      <BodyText color="inverted" align="center" className="cn_wrap-text" as="span">
        {children}
      </BodyText>
    </FlexDynamic>
  );
};
